import { render, staticRenderFns } from "./MenuUrlPicker.vue?vue&type=template&id=2dfcece4&scoped=true"
import script from "./MenuUrlPicker.vue?vue&type=script&lang=js"
export * from "./MenuUrlPicker.vue?vue&type=script&lang=js"
import style0 from "./MenuUrlPicker.vue?vue&type=style&index=0&id=2dfcece4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfcece4",
  null
  
)

export default component.exports